import React from 'react';
import { style } from 'typestyle';
import SearchIcon from 'mdi-react/SearchIcon';
import * as styles from './search-bar.styles';

interface Props {
  readonly maxLength?: number;
  readonly type?: string;
  readonly disabled?: boolean;
  readonly placeholder?: string;
  readonly onSearch: (query: string) => void;
}
const SearchBar = ({ maxLength, type, disabled = false, placeholder, onSearch }: Props): React.JSX.Element => (
  <div className={style(styles.searchBarContainer)}>
    <SearchIcon className={style(styles.searchIcon)} />
    <input
      className={style(styles.searchBar(disabled))}
      maxLength={maxLength}
      type={type}
      disabled={disabled}
      placeholder={placeholder}
      onChange={(event): void => {
        onSearch(event.target.value);
      }}
    />
  </div>
);

export default SearchBar;
